import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ErrorMessage from "../components/errorMessage";

const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

const CountsList = styled.ul`
  margin: 0 0 1rem;
  padding-left: 1.25rem;
`;

const IssueList = styled.ul`
  margin: 0.5rem 0 1.5rem;
  padding-left: 1.25rem;
`;

export interface ExcelImportSummaryDialogProps {
  show: boolean;
  onHide: () => void;
  createdCount?: number;
  updatedCount?: number;
  errors?: string[];
  warnings?: string[];
}

const ExcelImportSummaryDialog: React.FC<ExcelImportSummaryDialogProps> = ({
  show,
  onHide,
  createdCount,
  updatedCount,
  errors = [],
  warnings = [],
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      visible={show}
      style={{ width: "600px" }}
      onHide={onHide}
      header={t("excel-import-summary-header")}
    >
      <CountsList>
        {createdCount !== undefined && (
          <li>{t("excel-import-created-count", { count: createdCount })}</li>
        )}
        {updatedCount !== undefined && (
          <li>{t("excel-import-updated-count", { count: updatedCount })}</li>
        )}
      </CountsList>

      {warnings.length > 0 && (
        <>
          <ErrorMessage
            type="warning"
            summary={t("excel-import-warnings-header")}
          />
          <IssueList>
            {warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </IssueList>
        </>
      )}

      {errors.length > 0 && (
        <>
          <ErrorMessage
            type="error"
            summary={t("excel-import-errors-header")}
          />
          <IssueList>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </IssueList>
        </>
      )}

      <DialogActions>
        <Button
          type="button"
          label={t("cmd-close")}
          className="p-button-primary"
          onClick={onHide}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ExcelImportSummaryDialog;
